import Main from './Main'

export default [
  { path: '/', component: Main, children: [
      {path: '', component: () => import('./components/Dash1'), name: 'dashboard.main'},
      {path: 'dash/cadastros', component: () => import('./components/DashboardCadastro'), name: 'dashboard.cadastros'}
    ] }
]
